export var IMAGE_LOADING_COMPLETE = 'IMAGE_LOADING_COMPLETE';
export var RELOAD_IMAGES = 'RELOAD_IMAGES';
export var IMAGE_LOADING_START = 'IMAGE_LOADING_START';
